// function changeTab(e) {
//   var currentButton = e.target;
//   var id = currentButton.getAttribute("data-id");
//   var tabButtons = document.querySelectorAll(".tab-button");
//   var textInputs = document.querySelectorAll(".pplr-wrapper.pplr-text");

//   textInputs.forEach(function (input) {
//     input.style.display = "none";
//   });

//   tabButtons.forEach(function (button) {
//     button.classList.remove("active");
//   });

//   var selected = document.querySelector('[data-main="' + id + '"]');

//   selected.style.display = "block";
//   currentButton.classList.add("active");
// }

var mutationObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    var colors = document.querySelectorAll(".pplr-selecter-item");
    // var textInputs = document.querySelectorAll(".pplr-wrapper.pplr-text");
    var personalizerWrapper = document.querySelector(".product-personalizer");

    if (personalizerWrapper) {
      // Remove so there's no duplicates
      // var existingTextInputs = personalizerWrapper.querySelectorAll(
      //   "input.tabbable-input"
      // );
      // existingTextInputs.forEach(function (input) {
      //   input.remove();
      // });

      // var count = 0;

      // textInputs.forEach(function (input) {
      //   //input.setAttribute('type', 'hidden');

      //   var id = input.getAttribute("data-main");
      //   if (count > 0) {
      //     input.style.display = "none";
      //   } else {
      //     var wrapper = document.querySelectorAll(".tab-buttons");
      //     if (wrapper.length < 1) {
      //       var tabsLabelWrapper = document.createElement("div");
      //       var tabsLabel = document.createElement("label");
      //       var tabButtons = document.createElement("div");
      //       var buttonCount = 0;

      //       tabsLabelWrapper.classList.add("pplr-wrapper");
      //       tabsLabel.innerHTML = "Add text";
      //       tabsLabel.classList.add("pplrlabel");
      //       tabButtons.classList.add("tab-buttons");

      //       tabsLabelWrapper.append(tabsLabel);

      //       personalizerWrapper.insertBefore(tabsLabelWrapper, input);
      //       personalizerWrapper.insertBefore(tabButtons, input);

      //       textInputs.forEach(function (ogInput) {
      //         var ogId = ogInput.getAttribute("data-main");
      //         var labelWrapper = ogInput.querySelector("label");
      //         var label = labelWrapper.innerHTML;
      //         labelWrapper.style.display = "none";

      //         var button = document.createElement("button");
      //         button.innerHTML = label;
      //         button.classList.add("tab-button");
      //         button.setAttribute("type", "button");
      //         button.setAttribute("data-id", ogId);
      //         button.setAttribute("onclick", "changeTab(event)");

      //         if (buttonCount < 1) {
      //           button.classList.add("active");
      //         }

      //         tabButtons.appendChild(button);

      //         buttonCount++;
      //       });
      //     }
      //   }
      //   count++;
      // });

      var first = document.querySelector(
        'span[name="properties[Choose design]"]'
      );
      if (first) {
        first.click();
      }
    }

    colors.forEach(function (color) {
      var dataVal = color.getAttribute("data-val");
      if (!dataVal) return;
      if (dataVal.indexOf("#") == 0) {
        color.style.backgroundColor = dataVal;
      } else if (dataVal == "Natural") {
        color.style.backgroundImage =
          "url(//cdn.shopify.com/s/files/1/0519/6257/7073/t/4/assets/wood_100x.jpg)";
      } else if (dataVal == "Woodstain") {
        color.style.backgroundImage =
          "url(//cdn.shopify.com/s/files/1/0519/6257/7073/t/4/assets/oil_100x.jpg)";
      }
    });
  });
});

mutationObserver.observe(document.documentElement, {
  childList: true,
});
